import { readStorageJson } from '../utils/safeJson'

export function alarmStorageKey(filtersPrefix, suffix) {
  return 'af.' + filtersPrefix + '.' + suffix
}

export function readAlarmStorage(filtersPrefix, suffix, fallback = null) {
  return readStorageJson(alarmStorageKey(filtersPrefix, suffix), fallback)
}

export function hasAlarmStorage(filtersPrefix, suffix) {
  return localStorage.getItem(alarmStorageKey(filtersPrefix, suffix)) !== null
}

export function writeStorageJson(key, value) {
  if (typeof value === 'undefined') {
    localStorage.removeItem(key)
    return
  }

  localStorage.setItem(key, JSON.stringify(value))
}

export function writeAlarmStorage(filtersPrefix, suffix, value) {
  writeStorageJson(alarmStorageKey(filtersPrefix, suffix), value)
}

export function saveAlarmStorageValues(filtersPrefix, values) {
  Object.entries(values).forEach(([field, value]) => {
    writeAlarmStorage(filtersPrefix, field, value)
  })
}
